var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAquantLogoMainWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 700.3 162.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{isolation:isolate;opacity:0.06;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:#f6f6f6;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -81.14,
    y1: 160.2,
    x2: 148.83,
    y2: 71.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#1dcaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#2468ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 4.29,
    y1: 100.38,
    x2: 173.97,
    y2: 112.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2468ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1dcaff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152,161.58a18.48,18.48,0,0,1-6-3.22l-.06-.05c-4.72-3.88-13.92-28.18-16.61-34.42q-2.71-6.27-5.52-12.49l-.31-.69A347.35,347.35,0,0,0,105.91,76l0-.06c-5.41-8.86-10.35-14.72-14-14.72-7,0-17.35,16.43-29.19,38.84l-.32.6,0,0,0,.06C49.8,124.71,38,154.51,39.24,159.4c0,.2.18.46-.14.67l-.15,0-.08,0-.71.2a52.47,52.47,0,0,1-9.88,2.22A47.86,47.86,0,0,1,13,160.93C.89,156.7-1.65,146.84.89,135.1c4.3-20.36,47.52-88.91,61.57-110.46C69.18,14.3,78.07,0,92,0c12.08,0,20.16,11.43,26.9,20.29,4.09,5.39,14.55,22.06,24.6,38.77l.09.14c4.78,8,9.47,15.91,13.34,22.65,2,3.58,4,7.16,5.92,10.85,0,0,0,0,0,0a181,181,0,0,1,10.87,24.8q1.09,3.06,2,6.16a123.55,123.55,0,0,1,3.87,17.43C181.79,156.6,165.49,163.48,152,161.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.85,102.9c-4.66-.31-23.63,2.9-42.13,12.68q-1.08-2.44-2.19-4.89A349.48,349.48,0,0,0,105.89,76c-.4-.65-.79-1.29-1.18-1.89,11-8.16,22.05-16.42,34.25-22.51,1.5,2.47,3,5,4.54,7.5,4.8,8,9.53,16,13.42,22.79,2,3.56,4,7.16,5.93,10.85Q165.49,97.73,167.85,102.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152,161.58a18.68,18.68,0,0,1-6.05-3.26c-2.37-1.95-5.86-9-9.09-16.36,16.63-6.26,30.1-26.24,33.63-32.87,1.14,2.79,2.22,5.59,3.22,8.43a125.3,125.3,0,0,1,5.89,23.59C181.8,156.6,165.51,163.48,152,161.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M211.78,108.92c-1.51,17.24-10.77,37.16-22.55,45.54s-21,8.61-29.32,8.43h-1a24.61,24.61,0,0,1-6.86-1.28,18.68,18.68,0,0,1-6-3.26H146c9,1.58,23.82-19.36,29.74-34.68a49.9,49.9,0,0,0,1.87-5.79c1.74-7,5.08-20.11-3.28-24.5-3.52-1.85-7.63-1.59-11.48-.67-1.49.36-3,.82-4.32,1.29-12.21,4.2-23.57,10.68-34.72,17.39-5.65,3.4-11.24,6.85-16.87,10.09-13.46,7.76-26.88,15.62-40.34,23.4q-2.34,1.38-4.7,2.73l-3.37,1.93-3.67,2.1-1.16.66-1.31.75-2,1.1-2.94,1.64-1.37.75-.16.09a56.65,56.65,0,0,1-6.88,3.43l-.15,0-.08,0h-.08c-3.29,0-2.94-4.78-.63-11.66s6.69-16.16,11.25-24.9c.54-1,1.09-2.08,1.64-3.11.19-.34.37-.69.56-1,.48-.9,1-1.79,1.45-2.66,3.52-6.43,6.89-12.17,9.29-16h0l0,0c.1-.18.21-.35.32-.52.77-.52,2-1.29,3.71-2.25,8.06-4.65,25.38-13.86,39.44-21.91l0,0c2.25-1.29,4.37-2.49,6.33-3.52A167.63,167.63,0,0,1,143.6,59.2a98.06,98.06,0,0,1,21.34-4c13.29-.88,26.33,3.09,35.34,13.2C210.07,79.27,213,95,211.78,108.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.62,144.89l-8.07,4.66-3.67,2.1-1.16.66-1.31.75-2,1.1-2.94,1.64-1.37.75-.16.09a56.65,56.65,0,0,1-6.88,3.43l-.15,0-.15,0c-3.29,0-2.94-4.77-.64-11.65s6.69-16.16,11.25-24.9c.54-1,1.09-2.08,1.64-3.11.19-.34.37-.69.56-1,.48-.9,1-1.79,1.45-2.66,3.52-6.43,6.89-12.17,9.29-16h0l.06-.1.3-.47c.77-.52,2-1.29,3.71-2.25l1.2-.68C65.58,106.36,56.34,136.13,66.62,144.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M234,77.92c0-21.81,14.92-37.33,34.7-37.33,11.16,0,18.72,4.28,23.45,10.19l.37-8.68h18.81V114H292.52l-.37-8.69c-4.73,6-12.28,10.19-23.45,10.19C248.92,115.54,234,99.72,234,77.92Zm38.44-20.16c-11.51,0-19.33,8.69-19.33,20.16s7.79,20.53,19.33,20.53,19.63-9,19.63-20.53S283.9,57.76,272.44,57.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M378.57,50.78l.36-8.68h18.52V144H378.19V106.47c-4.79,5.47-12.81,9.07-23.38,9.07-20.37,0-34.83-15.44-34.83-37.18s14.46-37.77,34.83-37.77C366.35,40.59,373.77,44.79,378.57,50.78Zm-19.78,7c-11.51,0-19.49,8.85-19.49,20.46,0,11.39,8,20,19.49,20,11.31,0,19.55-8.62,19.55-20S370.08,57.83,358.79,57.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M457.8,42.08H477V84.42c0,18.21-13.71,31.1-34,31.1s-33.64-12.74-33.64-30.65V42.08h19.25V82.47c0,9.15,5.93,15.35,14.39,15.35,8.91,0,14.84-6.22,14.84-15.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M484.73,77.92c0-21.81,14.9-37.33,34.68-37.33,11.16,0,18.74,4.28,23.45,10.19l.38-8.68H562V114h-18.8l-.38-8.69c-4.71,6-12.27,10.19-23.45,10.19C499.63,115.54,484.73,99.72,484.73,77.92Zm38.42-20.16c-11.5,0-19.32,8.69-19.32,20.16s7.79,20.53,19.32,20.53,19.64-9,19.64-20.53S534.62,57.76,523.15,57.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M643.78,68.85V114H624.53V73.79c0-10-6.44-15.35-14.83-15.35s-16,5.37-16,15.35V114H574.56v-72h18.28l.38,8.32c3.74-5,11.46-9.82,22.17-9.82C632,40.59,643.78,51.54,643.78,68.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M678.93,58.06v29.6c0,7.5,4.19,10.79,10.63,10.79a86.71,86.71,0,0,0,10.68-.87l.06,16.36a40,40,0,0,1-8.83,1.53c-6.37.23-13,.12-18.85-2.54a20.85,20.85,0,0,1-10-9.36,28.47,28.47,0,0,1-2.85-13.15V58.05H647.61v-16h12.21V19H678.5V42.08h17V58Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAquantLogoMainWhite);
export default __webpack_public_path__ + "static/media/Aquant_Logo_Main_White.e80182251154640fa0d8be140f213ae6.svg";
export { ForwardRef as ReactComponent };